<template>
  <div>
    <div class="a-tab__title-block">
      <h3>Дополнительная информация</h3>
    </div>

    <div class="a-container-form admin-buy__block">
      <textarea class="a-textarea"
                placeholder="Укажите комментарий для участника по заполнению этого поля в предложении"
                v-model.lazy="lot.additionalInfo"></textarea>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      lot: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped>

</style>
